import { storageKey } from '@invite/app-core';
import type { OwnedUnit } from '../api/schemas';

const readRememberedId = (): number | null => {
  try {
    const raw = localStorage.getItem(storageKey('unitId'));
    return raw === null ? null : Number(raw);
  } catch {
    return null;
  }
};

/**
 * Remembered unit if it is listed and lives in the token's team (a unit of another team would
 * pair it with the wrong token), else the first unit of the token's team. Never a unit of another
 * team: reaching one takes a team switch, which the gate does before this provider mounts.
 */
export const initialUnit = (units: OwnedUnit[], teamId: number | null): OwnedUnit | undefined => {
  const remembered = readRememberedId();
  return (
    units.find((u) => u.id === remembered && u.teamId === teamId) ??
    units.find((u) => u.teamId === teamId)
  );
};
